import { useState, type FormEvent } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext.js";

export function LoginPage() {
  const { user, login, loading } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  if (loading)
    return (
      <div style={{ padding: "2rem", color: "var(--text-dim)" }}>
        Загрузка...
      </div>
    );
  if (user) return <Navigate to="/" replace />;

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await login(email, password);
    } catch (err) {
      setError(err instanceof Error ? err.message : "Ошибка входа");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        padding: "2rem",
      }}
    >
      <form
        onSubmit={onSubmit}
        style={{
          background: "var(--bg-elevated)",
          border: "1px solid var(--border)",
          borderRadius: 12,
          padding: "2rem",
          width: "100%",
          maxWidth: 360,
        }}
      >
        <h1 style={{ margin: "0 0 0.25rem", fontSize: "1.4rem" }}>
          Six Reasons Ads
        </h1>
        <p
          style={{
            color: "var(--text-dim)",
            fontSize: "0.85rem",
            margin: "0 0 1.5rem",
          }}
        >
          агент Я.Директа · вход
        </p>

        <label style={{ display: "block", marginBottom: "1rem" }}>
          <span
            style={{
              display: "block",
              fontSize: "0.75rem",
              color: "var(--text-dim)",
              marginBottom: "0.3rem",
              textTransform: "uppercase",
              letterSpacing: "0.04em",
            }}
          >
            Email
          </span>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            autoComplete="username"
            autoFocus
          />
        </label>

        <label style={{ display: "block", marginBottom: "1.25rem" }}>
          <span
            style={{
              display: "block",
              fontSize: "0.75rem",
              color: "var(--text-dim)",
              marginBottom: "0.3rem",
              textTransform: "uppercase",
              letterSpacing: "0.04em",
            }}
          >
            Пароль
          </span>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            autoComplete="current-password"
          />
        </label>

        {error && (
          <div
            style={{
              color: "var(--red)",
              fontSize: "0.8rem",
              marginBottom: "1rem",
              padding: "0.5rem 0.7rem",
              background: "rgba(248,113,113,0.08)",
              borderRadius: 6,
              border: "1px solid rgba(248,113,113,0.3)",
            }}
          >
            {error}
          </div>
        )}

        <button
          type="submit"
          className="primary"
          disabled={submitting}
          style={{ width: "100%", padding: "0.65rem 1rem", fontWeight: 600 }}
        >
          {submitting ? "Вход..." : "Войти"}
        </button>
      </form>
    </div>
  );
}
